import { render, staticRenderFns } from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=template&id=b9cb941a&scoped=true"
import script from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=style&index=0&id=b9cb941a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cb941a",
  null
  
)

export default component.exports